import { createAction } from 'redux-actions';

const types = {
  HOTEL_SEARCH_INIT_CLEAVER: 'HOTEL_SEARCH_INIT_CLEAVER',
  HOTEL_SELECT_HOTEL_CLEVER: 'HOTEL_SELECT_HOTEL_CLEVER',
  HOTEL_SELECT_ROOM_CLERVER: 'HOTEL_SELECT_ROOM_CLERVER',
  HOTEL_GUEST_DETAIL_SUBMIT_CLEVER: 'HOTEL_GUEST_DETAIL_SUBMIT_CLEVER',
  HOTEL_PAYMENT_SUCCESS_CLEVER: 'HOTEL_PAYMENT_SUCCESS_CLEVER',
};

const actionCreators = {
  trackSearchInitClever: createAction(types.HOTEL_SEARCH_INIT_CLEAVER),
  trackSelectHotelClever: createAction(types.HOTEL_SELECT_HOTEL_CLEVER),
  tractSelectRoomClever: createAction(types.HOTEL_SELECT_ROOM_CLERVER),
  trackGuestDetailSubmitedClever: createAction(
    types.HOTEL_GUEST_DETAIL_SUBMIT_CLEVER
  ),
  trackPaymentSuccessClever: createAction(types.HOTEL_PAYMENT_SUCCESS_CLEVER),
};

export { types, actionCreators };
